import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { RoutingFilterItem } from '../../types/RoutingFilterItem';
import { FilterGroup, GroupedRoutingFilterView } from '../groupedView/GroupedRoutingFilterView';

export type DomainGroupedRoutingFilterViewProps = Readonly<{
  filters: ReadonlyArray<RoutingFilterItem>;
  isLoading: boolean;
}>;

function groupFiltersByDomain(filters: ReadonlyArray<RoutingFilterItem>): FilterGroup[] {
  const domainMap: Record<string, RoutingFilterItem[]> = {};

  for (const filter of filters) {
    const key = filter.domain;
    if (!domainMap[key]) {
      domainMap[key] = [];
    }
    domainMap[key].push(filter);
  }

  const groups: FilterGroup[] = [];
  for (const domain of Object.keys(domainMap)) {
    groups.push({
      key: domain,
      label: domain,
      filters: domainMap[domain],
      preFill: { domainName: domain },
    });
  }

  return groups;
}

export function DomainGroupedRoutingFilterView(props: DomainGroupedRoutingFilterViewProps) {
  const { filters, isLoading } = props;

  const groups = React.useMemo(() => groupFiltersByDomain(filters), [filters]);

  return (
    <GroupedRoutingFilterView
      groupHeaderLabel={Messages.bridgeSiteSettingsDomain()}
      countHeaderLabel={Messages.bridgeSiteSettingsRoutingFiltersColumn()}
      groups={groups}
      isLoading={isLoading}
      testIdPrefix={'domain-routing-filters'}
    />
  );
}
